import { faPause, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import React, { useState, useEffect, useRef } from 'react';

// Global event for pausing all audio
const AUDIO_STOP_EVENT = 'AUDIO_STOP_EVENT';

function emitStopAudio() {
  window.dispatchEvent(new Event(AUDIO_STOP_EVENT));
}

export function AudioPlayer({ url }) {
  const [isPlay, setIsPlay] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    audioRef.current = new Audio(url);
    setIsPlay(false);
    return () => {
      audioRef.current.pause();
      audioRef.current = null;
    };
  }, [url]);

  useEffect(() => {
    const handleEnded = () => setIsPlay(false);
    const handleStop = () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        setIsPlay(false);
      }
    };
    if (audioRef.current) {
      audioRef.current.addEventListener('ended', handleEnded);
    }
    window.addEventListener(AUDIO_STOP_EVENT, handleStop);
    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener('ended', handleEnded);
      }
      window.removeEventListener(AUDIO_STOP_EVENT, handleStop);
    };
  }, []);

  const handleAudio = () => {
    if (!isPlay) {
      emitStopAudio(); // Stop all other audio
      setIsPlay(true);
      audioRef.current.play();
    } else {
      setIsPlay(false);
      audioRef.current.pause();
    }
  };

  return (
    <>
      <Button
        outline
        color="primary"
        style={{ border: '0px' }}
        onClick={handleAudio}
      >
        {isPlay ? (
          <FontAwesomeIcon icon={faPause} />
        ) : (
          <FontAwesomeIcon icon={faPlay} />
        )}
      </Button>
    </>
  );
}

// If you use the Player component, update it similarly:
export const Player = ({ url }) => {
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    audioRef.current = new Audio(url);
    setPlaying(false);
    return () => {
      audioRef.current.pause();
      audioRef.current = null;
    };
  }, [url]);

  useEffect(() => {
    const handleEnded = () => setPlaying(false);
    const handleStop = () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        setPlaying(false);
      }
    };
    if (audioRef.current) {
      audioRef.current.addEventListener('ended', handleEnded);
    }
    window.addEventListener(AUDIO_STOP_EVENT, handleStop);
    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener('ended', handleEnded);
      }
      window.removeEventListener(AUDIO_STOP_EVENT, handleStop);
    };
  }, []);

  const toggle = () => {
    if (!playing) {
      emitStopAudio();
      setPlaying(true);
      audioRef.current.play();
    } else {
      setPlaying(false);
      audioRef.current.pause();
    }
  };

  return (
    <div>
      <Button
        outline
        color="primary"
        style={{ border: '0px' }}
        onClick={toggle}
      >
        {playing ? (
          <FontAwesomeIcon icon={faPause} />
        ) : (
          <FontAwesomeIcon icon={faPlay} />
        )}
      </Button>
    </div>
  );
};
